
export default class UTCTimestamp {

  private utcTimestamp: number;

  constructor(seconds?: number) {
    if ( seconds ) {
      this.utcTimestamp = seconds;
    }
    else {
      this.utcTimestamp = Math.floor(new Date().getTime() / 1000);
    }
  }

  public toDate(): Date {
    return new Date(this.utcTimestamp * 1000);
  }

  public toSeconds(): number {
    return this.utcTimestamp;
  }

}
